/* Phase 5 · HR-Lite — Staff master (non-app floor workers + view of app users) */
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function StaffMaster() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: "", role_title: "", opening_casual: 12, opening_sick: 8, opening_other: 0 });
  const [managers, setManagers] = useState([]);

  const load = () => api.get("/hr/staff").then(r => setRows(r.data));
  useEffect(() => {
    load();
    api.get("/users/inspectors").catch(() => ({ data: [] })).then(() => {
      // supervisor/coord/director list — reuse /users
      api.get("/users").catch(() => ({ data: [] })).then(r => {
        setManagers((r.data || []).filter(u => ["supervisor", "coordinator", "director", "prod_qc_coordinator"].includes(u.role)));
      });
    });
  }, []);

  const submit = async () => {
    if (!form.name.trim()) return toast.error("Name required");
    try {
      await api.post("/hr/staff", form);
      toast.success("Staff added");
      setForm({ name: "", role_title: "", opening_casual: 12, opening_sick: 8, opening_other: 0 });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 md:p-6 max-w-5xl" data-testid="hr-staff">
      <div className="mb-4">
        <div className="text-[11px] uppercase tracking-widest text-[#7C8E9E]">HR — ATTENDANCE ONLY</div>
        <h1 className="text-2xl md:text-3xl font-bold text-[#0B2340]">Staff Master</h1>
        <p className="text-xs text-[#7C8E9E]">
          Weavers are piece-rate and appear nowhere in HR. Only office + factory floor + inspectors.
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg border border-slate-100 mb-6">
        <h3 className="text-sm font-semibold text-[#0B2340] mb-3">Add non-app staff (floor workers)</h3>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
          <input placeholder="Name" className="border rounded px-2 py-1.5 text-sm"
            data-testid="hr-staff-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <input placeholder="Role (e.g. Clipper)" className="border rounded px-2 py-1.5 text-sm"
            value={form.role_title} onChange={e => setForm({ ...form, role_title: e.target.value })} />
          <input type="number" placeholder="Casual" className="border rounded px-2 py-1.5 text-sm"
            value={form.opening_casual} onChange={e => setForm({ ...form, opening_casual: e.target.value })} />
          <input type="number" placeholder="Sick" className="border rounded px-2 py-1.5 text-sm"
            value={form.opening_sick} onChange={e => setForm({ ...form, opening_sick: e.target.value })} />
          <input type="number" placeholder="Other" className="border rounded px-2 py-1.5 text-sm"
            value={form.opening_other} onChange={e => setForm({ ...form, opening_other: e.target.value })} />
        </div>
        <button onClick={submit} data-testid="hr-staff-add"
          className="mt-3 px-4 py-2 rounded-full bg-[#B08B49] text-white text-sm">+ Add staff</button>
      </div>

      <div className="bg-white rounded-lg border border-slate-100 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="text-[11px] uppercase tracking-wider text-[#7C8E9E]">
            <tr className="border-b border-slate-100">
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Role</th>
              <th className="text-left p-3">Source</th>
              <th className="text-right p-3">Casual</th>
              <th className="text-right p-3">Sick</th>
              <th className="text-right p-3">Other</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-b border-slate-50">
                <td className="p-3 font-medium">{r.name}</td>
                <td className="p-3 text-xs">{r.role_title}</td>
                <td className="p-3 text-xs">
                  {r.is_app_user ? <span className="text-blue-700">App user</span> : <span className="text-[#7C8E9E]">Manual</span>}
                </td>
                <td className="p-3 text-xs text-right">{r.opening_balance?.casual ?? "—"}</td>
                <td className="p-3 text-xs text-right">{r.opening_balance?.sick ?? "—"}</td>
                <td className="p-3 text-xs text-right">{r.opening_balance?.other ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
